import React from 'react';

import { observer } from 'mobx-react';

import CustomModal from 'components/CustomModal';
import { Button } from 'components/Button';

import UserAndGroupPicker, { PickerValue } from 'components/SharedFormComponents/UserAndGroupPicker';

import { useStore } from 'utils/hooks/store';

interface AddMembersModalProps {
  open: boolean;
  onClose: () => void;
}

const AddMembersModal: React.FunctionComponent<AddMembersModalProps> = observer(({ open, onClose }) => {
  const { memberGroupDetails } = useStore();
  const groupUuid = memberGroupDetails.group?.uuid;

  const [selected, setSelected] = React.useState<PickerValue[]>([]);
  const [saving, setSaving] = React.useState(false);

  const handleClose = (): void => {
    setSelected([]);
    onClose();
  };

  const handleAdd = async (): Promise<void> => {
    if (selected.length === 0) {
      return;
    }
    setSaving(true);
    const ok = await memberGroupDetails.addMembers(selected.map(({ uuid }) => uuid));
    setSaving(false);
    if (ok) {
      handleClose();
    }
  };

  return (
    <CustomModal
      openModal={open}
      onClose={handleClose}
      modalTitle="Add users"
      cancelButton={
        <Button variant="outlined" size="large" onClick={handleClose}>
          Cancel
        </Button>
      }
      submitButton={
        <Button variant="contained" size="large" onClick={handleAdd} disabled={saving || selected.length === 0}>
          Add
        </Button>
      }
    >
      <UserAndGroupPicker
        value={selected}
        onChange={setSelected}
        excludeMemberGroupUuid={groupUuid}
        placeholder="Select users"
        emptyUsersText="Everyone is already a member"
      />
    </CustomModal>
  );
});

export default AddMembersModal;
